import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//人才活动模板查询
export const GetActivityTemplePage = (data) => {
  return axios.post(`${base}/api/ActivityTemple/GetActivityTemplePage`, data);
};

//删除活动模板
export const DeleteActivityTemple = (params) => {
  return axios.delete(`${base}/api/ActivityTemple/DeleteActivityTemple`, {
    params: params,
  });
};

//新增活动模板查询
export const PostAddActivityTemple = (data) => {
  return axios.post(`${base}/api/ActivityTemple/PostAddActivityTemple`, data);
};

//活动模板详情查询
export const GetActivityTempleById = (params) => {
  return axios.get(`${base}/api/ActivityTemple/GetActivityTempleById`, {
    params,
  });
};

//活动模板更新
export const PutActivityTemple = (data) => {
  return axios.post(`${base}/api/ActivityTemple/PutActivityTemple`, data);
};

//分页查询人才活动报名信息
export const GetActivityInfoPage = (data) => {
  return axios.post(`${base}/api/ActivityTemple/GetActivityInfoPage`, data);
};
